import { render, staticRenderFns } from "./stockpackstatistical-list.vue?vue&type=template&id=6c6596f8&scoped=true&"
import script from "./stockpackstatistical-list.vue?vue&type=script&lang=ts&"
export * from "./stockpackstatistical-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6596f8",
  null
  
)

export default component.exports